"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _backToTopButton = _interopRequireDefault(require("../back-to-top-button/back-to-top-button"));

var _errorBoundary = _interopRequireDefault(require("../error-boundary/error-boundary"));

var _breadcrumb = _interopRequireDefault(require("../breadcrumb/breadcrumb"));

var _content = _interopRequireDefault(require("./components/content"));

var _sidebar = _interopRequireDefault(require("./components/sidebar"));

var _exampleIndex = require("./components/example-index");

var _utils = require("./utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _layoutConfig = _interopRequireDefault(require("./layout.config.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* prevent flex-child from overflowing on IE 11 */
var ie11FlexChild = {
  width: '100%'
};

var PageLayout = /*#__PURE__*/function (_React$Component) {
  _inherits(PageLayout, _React$Component);

  var _super = _createSuper(PageLayout);

  function PageLayout() {
    var _this;

    _classCallCheck(this, PageLayout);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderSidebar", function (config, switchedNavigation, parentPath) {
      var constants = _this.props.constants;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "flex-child flex-child--no-shrink w-full w180-mm w300-ml mr36-mm ".concat(config.sidebarTheme),
        style: ie11FlexChild
      }, /*#__PURE__*/_react.default.createElement(_sidebar.default, _extends({}, _this.props, {
        navigation: switchedNavigation,
        constants: constants,
        parentPath: parentPath,
        layoutConfig: config
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function (config, parentPath, parent, hasSection) {
      var _this$props = _this.props,
          constants = _this$props.constants,
          frontMatter = _this$props.frontMatter,
          location = _this$props.location,
          domain = _this$props.domain;
      var crumbs = (0, _utils.createUniqueCrumbs)([domain].concat(_toConsumableArray(hasSection ? [{
        title: hasSection.title,
        path: "".concat(constants.BASEURL, "/").concat(hasSection.path, "/")
      }] : [{
        title: constants.SITE,
        path: "".concat(constants.BASEURL, "/")
      }]), _toConsumableArray(parent && parent.title ? [{
        title: parent.title,
        path: parent.parent
      }] : []), [{
        title: frontMatter.title,
        path: location.pathname
      }]));
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "flex-child flex-child--grow",
        style: ie11FlexChild
      }, !frontMatter.hideBreadcrumbs && /*#__PURE__*/_react.default.createElement(_breadcrumb.default, {
        themeWrapper: (0, _classnames.default)('pt3 pb12', {
          // hide breadcrumbs on mobile if sidebar is on the page
          // show breadcrumbs on mobile if sidebar is hidden from the page
          'none block-mm': !frontMatter.hideSidebar
        }),
        domain: false,
        location: location,
        links: crumbs
      }), /*#__PURE__*/_react.default.createElement(_content.default, _extends({}, _this.props, {
        parentPath: parentPath,
        layoutConfig: config
      })));
    });

    return _this;
  }

  _createClass(PageLayout, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          location = _this$props2.location,
          navigation = _this$props2.navigation,
          frontMatter = _this$props2.frontMatter;
      var navOrder = frontMatter.navOrder,
          noShellHeaderBuffer = frontMatter.noShellHeaderBuffer; // determine's if this is a single or multi-structured site (the latter has sections)

      var hasSection = (0, _utils.findHasSection)(navigation, location.pathname); // get the parent's path, we need this for the top nav

      var parentPath = (0, _utils.findParentPath)(navigation, location.pathname); // if page has `section` then switch to multi-page

      var switchedNavigation = hasSection ? navigation[hasSection.path] : navigation; // set default layout to page

      if (!frontMatter.layout) frontMatter.layout = 'page'; // if layout is example and has navOrder assume 'exampleIndex' layout

      var config = _objectSpread(_objectSpread({}, navOrder && frontMatter.layout === 'example' ? _layoutConfig.default.exampleIndex : _layoutConfig.default[frontMatter.layout]), frontMatter);

      return /*#__PURE__*/_react.default.createElement(_errorBoundary.default, null, !noShellHeaderBuffer && /*#__PURE__*/_react.default.createElement("div", {
        className: "shell-header-buffer"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "limiter limiter--wide"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "flex-parent-mm"
      }, !frontMatter.hideSidebar && /*#__PURE__*/_react.default.createElement(_errorBoundary.default, null, this.renderSidebar(config, switchedNavigation, parentPath)), /*#__PURE__*/_react.default.createElement(_errorBoundary.default, null, this.renderContent(config, parentPath, navigation.hierarchy[location.pathname], hasSection)))), /*#__PURE__*/_react.default.createElement("div", {
        className: "fixed block none-mm mx24 my24 z5 bottom right"
      }, /*#__PURE__*/_react.default.createElement(_backToTopButton.default, null)));
    }
  }]);

  return PageLayout;
}(_react.default.Component);

exports.default = PageLayout;
PageLayout.defaultProps = {
  domain: {
    title: 'All docs',
    path: 'https://docs.mapbox.com'
  },
  hideSearch: false
};
PageLayout.propTypes = {
  children: _propTypes.default.node,

  /** Provided by Batfish, the `pathname` (relative url) of the current page is required */
  location: _propTypes.default.shape({
    pathname: _propTypes.default.string.isRequired
  }).isRequired,

  /**
  `frontMatter` prop | Description | Conditions
  ---|---|---
  `layout` | One of: `page`, `example`, `full`, `exampleIndex`. |
  `navOrder` | If defined with a number, the page will be added to TabList in the navigation bar. This is the canonical way for defining a top-level page. |
  `order` | Defined by number, the order that pages should appear in the sidebar's NavigationAccordion |  `page` layout
  `hideTitle` | Hide the title of the page. |
  `hideFeedback` | Remove the feedback component from the bottom of the page. |
  `sidebarTheme` | Mapbox Assembly class names to style the sidebar container. | all layouts except `none`
  `hideCardLanguage` | If `true`, hide the language from all Cards. | `exampleIndex` layout
  `hideCardDescription` | If `true`, hide the description from all Cards. | `exampleIndex` layout
  `fullWidthCards` | Makes CardContainer full width. | `exampleIndex` layout
  `showCards` | Enable or disable the `CardsContainer`. This is helpful for pages like the dr-ui Components page. | `exampleIndex` layout
  `cardColSize` | A number to define the column sizes for the Cards | `exampleIndex` layout
  `unProse` | If `true`, remove the "prose" class from PageLayout. This is helpful for non-content pages. |
  `noShellHeaderBuffer` | If `true`, remove the header buffer div. This is helpful for custom headers like on the Help page. |
  `hideFromNav` | If `true`, remove an item from appearing in NavigationAccordion. (This is used in API docs.) | 
  `hideBreadcrumbs` | If `true`, remove the breadcrumbs. (This is used by Help home page.) |
  `hideSidebar` | If `true`, remove the sidebar. (This is used by Help home page and Playground.). This setting will also enable breadcrumbs to display on mobile (unless `hideBreadcrumbs: true`). |
  `showFilters` | All filters for an exampleIndex page are shown if the data is available. Use `showFilters` to define only the filters you want the page to display. | `exampleIndex` layout
  `onThisPage` | If unspecified, `<OnThisPage>` aside will appear on all pages with `layout: page`. If set to `false` for pages with `layout: page`, `<OnThisPage>` will be hidden. If set to `true` for pages with other layouts, `<OnThisPage>` will appear. |
  */
  frontMatter: _propTypes.default.shape({
    headings: _propTypes.default.array,
    // a set of headings that is automatically generated by Batfish
    navOrder: _propTypes.default.number,
    order: _propTypes.default.number,
    layout: _propTypes.default.oneOf(['page', 'example', 'exampleIndex', 'full']),
    hideTitle: _propTypes.default.bool,
    hideFeedback: _propTypes.default.bool,
    sidebarTheme: _propTypes.default.string,
    showCards: _propTypes.default.bool,
    fullWidthCards: _propTypes.default.bool,
    cardColSize: _propTypes.default.number,
    unProse: _propTypes.default.bool,
    noShellHeaderBuffer: _propTypes.default.bool,
    hideFromNav: _propTypes.default.bool,
    hideCardLanguage: _propTypes.default.bool,
    hideCardDescription: _propTypes.default.bool,
    hideBreadcrumbs: _propTypes.default.bool,
    hideSidebar: _propTypes.default.bool,
    title: _propTypes.default.string,
    showFilters: _propTypes.default.arrayOf(_propTypes.default.oneOf(_exampleIndex.filterOptions)),
    onThisPage: _propTypes.default.bool
  }).isRequired,

  /**
  - `navTabs` - links to be shown in the `NavigationAccordion`, formatted as an array of object: `[{"href": "/overview", "id": "overview", "label": "Overview"}]`
  - `hierarchy` - Object of every path and their parent: `{"/overview/layous": {"parent": "/overview", "title": "Overview"}}`
  - `title` - required for multi-structured layouts, this is the title for the `ProductMenu`
  - `tag` - optional `tag` name to pass to `ProductMenu`, [see available options](#productmenu).
  */
  navigation: _propTypes.default.shape({
    navTabs: _propTypes.default.array,
    hierarchy: _propTypes.default.object,
    title: _propTypes.default.string,
    tag: _propTypes.default.string
  }).isRequired,

  /** An object of filters. This dataset can be generated with [@mapbox/dr-ui/helpers/batfish/filters.js](https://mapbox.github.io/dr-ui/guides/batfish-helpers/#filters).*/
  filters: _propTypes.default.objectOf(_propTypes.default.shape({
    topics: _propTypes.default.array,
    pages: _propTypes.default.array,
    languages: _propTypes.default.array,
    levels: _propTypes.default.array,
    videos: _propTypes.default.bool
  })),

  /**
  - `SITE` - the name of the site.
  - `BASEURL` - the base url of the website, as used in the batfish.config.js
  - `FORWARD_EVENT_WEBHOOK` - an object with to values: `production` and `staging`.
  */
  constants: _propTypes.default.shape({
    SITE: _propTypes.default.string.isRequired,
    BASEURL: _propTypes.default.string.isRequired,
    FORWARD_EVENT_WEBHOOK: _propTypes.default.shape({
      production: _propTypes.default.string.isRequired,
      staging: _propTypes.default.string.isRequired
    }).isRequired
  }).isRequired,

  /** Required if using the `exampleIndex` layout along with `imageId`s. The value is the local `AppropriateImage` component. */
  AppropriateImage: _propTypes.default.func,

  /** For when headings are dynamic, this is used by API docs */
  headings: _propTypes.default.array,

  /** For `Feedback` component */
  feedbackSentryDsn: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /** The domain's title and homepage path to be added as the first Breadcrumb link */
  domain: _propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    path: _propTypes.default.string.isRequired
  }),

  /** Hide Search component from the sidebar */
  hideSearch: _propTypes.default.bool
};